export default __webpack_public_path__ + "static/media/template24.3a035727.svg";